import { createFileRoute, redirect } from "@tanstack/react-router";

// Las solicitudes ahora son leads con etapa de venta.
export const Route = createFileRoute("/_authenticated/app/solicitudes")({
  beforeLoad: () => {
    throw redirect({ to: "/app/leads" });
  },
});
